import { render } from "./posPrintMonitorModel.vue?vue&type=template&id=266b9e82"
import script from "./posPrintMonitorModel.vue?vue&type=script&lang=js"
export * from "./posPrintMonitorModel.vue?vue&type=script&lang=js"

import "./posPrintMonitorModel.vue?vue&type=style&index=0&id=266b9e82&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__